import React, { useMemo, useState } from 'react';

// Reusable grid picker: searchable, sortable list shown under a field. options: [{ value, label, aliases, description }]
export default function MedicationGridPicker({ options, onSelect, onClose, selectedValue }) {
    const [q, setQ] = useState('');
    const [sortDir, setSortDir] = useState(1);
    const rows = useMemo(() => {
        const s = q.toLowerCase().trim();
        return (options || [])
            .filter((o) => !s || String(o.label || '').toLowerCase().includes(s) || (o.aliases || []).some((a) => String(a).toLowerCase().includes(s)) || String(o.description || '').toLowerCase().includes(s))
            .slice()
            .sort((a, b) => sortDir * String(a.label || '').localeCompare(String(b.label || '')));
    }, [options, q, sortDir]);
    const th = { position: 'sticky', top: 0, background: '#f8f9fa', zIndex: 1 };
    return (
        <div style={{ border: '1px solid #ced4da', borderRadius: 6, marginTop: 4, background: '#fff', boxShadow: '0 4px 14px rgba(0,0,0,0.08)' }}>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: 8, borderBottom: '1px solid #e9ecef' }}>
                <i className="fas fa-search" style={{ color: '#6c757d' }}></i>
                <input
                    autoFocus
                    className="form-control form-control-sm"
                    placeholder="Search name, brand or alias…"
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Escape') { e.preventDefault(); onClose(); }
                        if (e.key === 'Enter') { e.preventDefault(); if (rows[0]) onSelect(rows[0]); }
                    }}
                />
                <span style={{ fontSize: 12, color: '#6c757d', whiteSpace: 'nowrap' }}>{rows.length} found</span>
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose}>Close</button>
            </div>
            <div style={{ maxHeight: 280, overflowY: 'auto' }}>
                <table className="table table-sm table-hover mb-0" style={{ fontSize: 13 }}>
                    <thead>
                        <tr>
                            <th style={{ ...th, width: '42%', cursor: 'pointer' }} onClick={() => setSortDir(-sortDir)}>Medication {sortDir > 0 ? '▲' : '▼'}</th>
                            <th style={th}>Aliases</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!rows.length && (
                            <tr><td colSpan="2" className="text-center text-muted p-3">No match. An admin can add it in Administration → Medications.</td></tr>
                        )}
                        {rows.map((o) => (
                            <tr key={o.value} onClick={() => onSelect(o)} style={{ cursor: 'pointer', background: o.value === selectedValue ? '#e7f1ff' : undefined }}>
                                <td>
                                    <div style={{ fontWeight: 600 }}>{o.label}</div>
                                    {o.description ? <small className="text-muted">{o.description}</small> : null}
                                </td>
                                <td style={{ color: '#6c757d' }}>{(o.aliases || []).join(', ') || '—'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
